<template>
  <div>
    <div class="table-header th-">
      <b-row>
        <b-col md="6" class="th-col">
          <h3>Project timeframes</h3>
        </b-col>
        <b-col md="6" class="th-col filter-col">
          <FilterByClientWebsite :items="items" @filterChange="updateFilter" :filterByClient="user.login_type===0"/>
        </b-col>
      </b-row>
    </div>

    <div v-if="months.length">
      <div v-for="month in months">
        <div class="month-table">
          <div class="month-ribbon">{{formatMonth(month)}}</div>
          <div class="table-holder">
            <b-table :items="monthItems(month)"
                     :fields="fields"
                     @row-clicked="openCard"
                     responsive
            >
              <template v-slot:cell(title)="data">
                <div class="value-box">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(retainer)="data">
                <div class="retainer-box" v-if="data.value">
                  <span>{{ data.value }}</span>
                </div>
              </template>
              <template v-slot:cell(project_id)="data">
                <div class="retainer-box" v-if="data.value">
                  <span>{{ data.value }}</span>
                </div>
              </template>
              <template v-slot:cell(ideation)="data">
                <div class="date-box" v-if="data.value">
                  <i :class="data.item.ideationIcon"></i><span>{{ formatDateBox(data.value) }}</span>
                </div>
                <div v-else class="tbd-box">TBD</div>
              </template>
              <template v-slot:cell(production)="data">
                <div class="date-box" v-if="data.value">
                  <i :class="data.item.productionIcon"></i><span>{{ formatDateBox(data.value) }}</span>
                </div>
                <div v-else class="tbd-box">TBD</div>
              </template>
              <template v-slot:cell(promotion)="data">
                <div class="date-box" v-if="data.value">
                  <i :class="data.item.promotionIcon"></i><span>{{ formatDateBox(data.value) }}</span>
                </div>
                <div v-else class="tbd-box">TBD</div>
              </template>
              <template v-slot:cell(report_sent)="data">
                <div class="date-box" v-if="data.value">
                  <i :class="data.item.reportSentIcon"></i><span>{{ formatDateBox(data.value) }}</span>
                </div>
                <div v-else class="tbd-box">TBD</div>
              </template>
            </b-table>
          </div>
        </div>
      </div>

    </div>

    <campaign-card :_campaignData="campaignData"
                   ref="campaignCard"
                   @done="campaignsInit"
    ></campaign-card>
  </div>
</template>

<script>
import Vue from 'vue';
const mm = Vue.mm;

export default {
  name: 'CampaignsTable',
  components: {
    'campaign-card': () => import('@/components/CampaignCard.vue'),
    'FilterByClientWebsite': () => import('@/components/FilterByClientWebsite.vue'),
  },
  props: {
    finished: {
      type: Boolean
    }
  },
  data: () => ({
    searchText: '',
    selected_client_id: null,
    selected_website: '',
    campaignData: null,
    fields: [
      {
        key: 'client_name',
        variant: 'client_name',
        label: 'Client',
        class: 'w-10'
      },
      {
        key: 'website',
        label: 'Website',
        class: 'w-10'
      },
      {
        key: 'title',
        variant: 'title',
        label: 'Project title',
        class: 'w-50'
      },
      {
        key: 'retainer',
        label: 'Retainer',
      },
      {
        key: 'project_id',
        label: 'Project',
      },
      {
        key: 'ideation',
        formatter: (value, key, item) => {
          if (item.idea_signoff) {
            return item.idea_signoff;
          }
          if (item.idea_sent) {
            return mm(item.idea_sent);
          }
          if (item.project_start) {
            return mm(mm(item.project_start).add(7,'days').toDate()).businessAdd(1,'days');
          }
          return '';
        }
      },
      {
        key: 'production',
        formatter: (value, key, item) => {
          if (item.prod_end) {
            return item.prod_end;
          }
          if (item.prod_sent) {
            return item.prod_sent;
          }

          // debugger

          if (item.prod_start) {
            return mm(item.prod_start,'YYYY-MM-DD').businessAdd(parseInt(item.prod_days)+2);
          }

          var idea_signoff = (function idea_signoff() {
            if (item.idea_signoff) {
              return item.idea_signoff;
            }
            if (item.idea_sent) {
              return mm(item.idea_sent,'YYYY-MM-DD').add(7,'days');
            }
            if (item.project_start) {
              return mm(item.project_start,'YYYY-MM-DD').businessAdd(7);
            }
          })()

          if (idea_signoff) {
            var prod_start = mm(idea_signoff,'YYYY-MM-DD').businessAdd(1).format('YYYY-MM-DD');
            return mm(prod_start,'YYYY-MM-DD').businessAdd(parseInt(item.prod_days)+2).format('YYYY-MM-DD');
          }
          return '';
        }
      },
      {
        key: 'promotion',
        label: 'Live URL',
        formatter: (value, key, item) => {
          let val = (item.promotion_start) ? mm(item.promotion_start).isoWeekday(1) : '';
          return val;
        }
      },
      {
        key: 'report_sent',
        label: 'Report expected',
        formatter: (value, key, item) => {
          let val = (item.promotion_end) ? item.promotion_end : item.promotion_start ? mm(item.promotion_start).businessAdd(25) : '';
          return val;
        }
      }],
  }),
  mounted: function () {
    if (this.user.login_type===1) {
      this.fields = this.fields.filter(e=>e.key!=='client_name');
    }
    this.campaignsInit();
  },
  methods: {
    updateFilter(clientId,website) {
      this.selected_client_id = clientId
      this.selected_website = website
    },
    selectValueInput(key, scope, refName, refInput) {
      if (key.keyCode === 13) {
        //Enter pressed, we'll check if the value exists
        let slOb = this.$refs[refInput];
        slOb.typeAheadSelect();
      }
    },
    formatDateBox(val) {
      return val ? this.$mm(val).format('MMM DD, YYYY') : '';
    },
    formatMonth(month) {
      return this.$mm(`${month}-01`).format('MMMM YYYY');
    },
    openCard(item) {
      if (this.user.login_type!==0) {
        return;
      }
      this.campaignData = item;
      this.$refs.campaignCard.show();
    },
    campaignsInit() {
      this.$store.dispatch('campaigns/getAll');
      this.$store.dispatch('campaigns/getPast');
    },
    monthItems(month) {
      let allItems = this.filteredItems.filter(e=>{
        let projMonth = this.$mm(e.project_start).format('YYYY-MM');
        return projMonth===month;
      });

      // debugger
      return allItems;
    }
  },
  computed: {
    allClients() {
      let allItems = this.$store.state.refs.clients_active || [];
      return allItems.length ? allItems : [];
    },
    allSites() {
      let allItems = this.items || [];
      if (!allItems.length) return [];

      allItems = allItems.reduce((acc,e)=>{
        if (acc.indexOf(e.website)<0) acc.push(e.website);
        return acc;
      },[]);

      allItems = allItems.sort((a,b)=>{
        return a > b ? -1 : 1;
      });

      return allItems;
    },
    months() {
      let allItems = this.filteredItems || [];

      if (!allItems.length) return allItems;

      allItems = allItems.reduce((acc,e)=>{
        let month = this.$mm(e.project_start);
        if (!month.isValid()) return acc;
        month = this.$mm(e.project_start).format('YYYY-MM');
        if (acc.indexOf(month)<0) acc.push(month);
        return acc;
      },[]);

      allItems = allItems.sort((a,b)=>{
        return a > b ? -1 : 1;
      });

      return allItems;
    },
    items() {
      let allItems = this.$store.state.campaigns.all || [];
      allItems = Array.isArray(allItems) ? allItems : [];
      // debugger
      allItems = allItems.map(e=>{
        const curDate = this.$mm();
        e._cellVariants = {
          ideation: (e.idea_signoff) ? 'success' : (e.project_start && this.$mm(e.project_start)<curDate) ? 'danger' : 'warning',
          production: (e.prod_end) ? 'success' : (e.prod_start && this.$mm(e.prod_start)<curDate) ? 'danger' : 'warning',
          promotion: (e.promotion_end) ? 'success' : (e.promotion_start) ? 'warning' : '',
          report_sent: (e.promotion_end) ? 'success' : '',
        };
        e.ideationIcon = e._cellVariants.ideation==='success' ? 'icon-calendar-tick' : 'icon-calendar-notick';
        e.productionIcon = e._cellVariants.production==='success' ? 'icon-calendar-tick' : 'icon-calendar-notick';
        e.promotionIcon = e._cellVariants.promotion==='success' ? 'icon-calendar-tick' : 'icon-calendar-notick';
        e.reportSentIcon = e._cellVariants.promotion_end==='success' ? 'icon-calendar-tick' : 'icon-calendar-notick';

        return e;
      });

      allItems = allItems.filter(e=>{
        return (e.project_end && this.finished) || (!e.project_end && !this.finished);
      });

      if (this.selected_client_id) {
        allItems = allItems.filter(e=>e.client_id===this.selected_client_id);
      }

      return allItems;
    },
    filteredItems() {
      let allItems = this.items || [];
      if (!allItems.length) return allItems;

      if (this.selected_website) {
        allItems = allItems.filter(i=>i.website===this.selected_website.name);
      }

      return allItems;
    },
    user() {
      return this.$store.state.authentication.user;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';

.month-table {
  background: #fff;
  padding: 15px 20px 20px;
  margin-bottom: 25px;
  border-radius: 6px;
  box-shadow: 0px 0px 9.4px 0.6px rgba(0, 0, 0, 0.1);
}

.month-ribbon {
  background: $violet;
  color: #fff;
  text-transform: uppercase;
  display: inline-block;
  padding: 8px 15px;
  margin-left: -20px;
  margin-bottom: 20px;
}

/deep/ .table {
  .table-client {
    @include xs {
      width: 100px;
      max-width: 100px;
      .value-box {
        word-wrap: break-word;
      }
    }
  }
  .table-title {
    @include xs {
      width: 200px;
      min-width: 200px;
    }
  }
  th {
    vertical-align: middle;
    &.w-10 {
      width: 10%;
    }
    &.w-50 {
      width: 50%;
    }
  }
  th,td {
    padding-left: 0;
    border-top: none;
    border-bottom: 1px solid $lgrey6;
  }
  td {
    padding: 0 15px 0 0;
    background: none;
    vertical-align: middle;
  }
  th {
    padding-top: 0;
    border-top: none;
    text-transform: uppercase;
    font-size: 12px;
    color: $lgrey;
  }
  tbody {
    tr {
      cursor: pointer;
    }
  }
  .table-success {
    .date-box {
      background: $success-lt;
    }
    i {
      color: $success;
    }
  }
  .table-danger {
    .date-box {
      background: $progress-lt;
    }
    i {
      color: $error;
    }
  }
  .value-box {
    display: flex;
    align-items: center;
  }
  .tbd-box, .date-box, .retainer-box {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $warning-lt;
    margin: 10px 0;
    padding: 8px 12px;
    border-radius: 4px;
    font-weight: 500;
    color: $text-muted;
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
  }
  .retainer-box {
    background: $lgrey4;
  }
  .date-box {
    i {
      margin-right: 10px;
      font-size: 20px;
    }
  }
}
</style>
